import { LANGUAGES, LANGUAGE_META, type Language } from '@astral/shared';
import { Icon } from '@astral/ui';

export interface LanguagePickerProps {
  value: Language;
  onSelect: (language: Language) => void;
}

/** A vertical list of language options, used in onboarding and settings. */
export function LanguagePicker({ value, onSelect }: LanguagePickerProps): JSX.Element {
  return (
    <div className="lang-picker">
      {LANGUAGES.map((code) => {
        const meta = LANGUAGE_META[code];
        const active = code === value;
        return (
          <button
            key={code}
            type="button"
            className={`lang-option${active ? ' lang-option--active' : ''}`}
            onClick={() => onSelect(code)}
            aria-pressed={active}
          >
            <span className="lang-option__flag">{meta.flag}</span>
            <span className="lang-option__text">
              <span className={`lang-option__native${active ? ' metallic-text' : ''}`}>
                {meta.nativeName}
              </span>
              <span className="lang-option__english">{meta.englishName}</span>
            </span>
            {active && (
              <span className="lang-option__check">
                <Icon name="check" size={22} />
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
